import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white border-2 border-gray-100 rounded-2xl p-8 md:p-10 text-center shadow-sm" data-id="element-65">
          <div className="flex justify-center mb-6" data-id="element-66">
            <ShieldCheck size={64} className="text-primary" data-id="element-67" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-68">
            🛡️ GARANTÍA
          </h2>
          <h3 className="text-xl font-bold text-primary mb-6" data-id="element-69">
            Probalo sin riesgo durante{' '}
            <span className="font-extrabold bg-yellow-200/60 px-1 rounded text-charcoal" data-id="element-70">
              7 días
            </span>
            .
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-71">
            👉 Si no sentís que te simplifica la vida o no lo usás, te{' '}
            <span className="font-bold underline decoration-accent decoration-2 underline-offset-2" data-id="element-72">
              devolvemos el dinero
            </span>
            . <br data-id="element-73" />
            <span className="font-bold text-charcoal mt-2 block" data-id="element-74">
              Sin preguntas. Sin vueltas.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}